import { ServicioDTO } from "../interfaces/servicio.interface";
import { DetalleServicioSeleccionado } from "./detalle-servicio-seleccionado.model";

export class ServicioSeleccionado {
    constructor(
        public servicio: ServicioDTO,
        public detalle: DetalleServicioSeleccionado
    ) {
        this.servicio = servicio;
        this.detalle = detalle;
    }
}
